import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";

const OnboardSlide8 = () => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.emoji}>💸</Text>

        <Text style={styles.title}>
          Based on your answers you missed out on...
        </Text>

        <Text style={styles.amount}>$968</Text>

        <Text style={styles.disclaimer}>
          *This is an approximation based on the average payouts from past class
          actions, unclaimed money, and junk subscriptions
        </Text>
      </View>
    </View>
  );
};

export default OnboardSlide8;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 32,
    justifyContent: "center",
  },
  content: {
    alignItems: "center",
    gap: 24,
  },
  emoji: {
    fontSize: 72,
    lineHeight: 73,
    textAlign: "center",
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    textAlign: "center",
    paddingHorizontal: 7,
  },
  amount: {
    fontFamily: FontFamilies.Inter.Bold,
    fontSize: 80,
    lineHeight: 90,
    color: "#161D14",
    textAlign: "center",
  },
  disclaimer: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
    letterSpacing: -0.32,
  },
});
